/**
 * Атрибуты на <html>, по которым Playwright понимает, чем закончилась гидрация.
 * data-app-hydrated — приложение смонтировалось и выполнило стартовые эффекты.
 * data-app-degraded — корневой error boundary показал снимок SSR-разметки.
 */
export const APP_HYDRATED_ATTRIBUTE = 'data-app-hydrated';
export const APP_DEGRADED_ATTRIBUTE = 'data-app-degraded';
